export default __webpack_public_path__ + "dfce570ad5c61fa9b32e667aa1d92cd9.jpg";